import React from 'react';

import { Box, Button, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import BreadCrumbs from 'src/components/atoms/breadcrumb';
import NextLink from 'src/components/atoms/link';

import { IBreadcrumb } from '@interfaces/app';
import { ICategory } from '@interfaces/category';
import { AllVersion } from 'src/types/learningPath';

type CourseHeaderBannerBreadcrumbProps = {
  courseName: string;
  learningPath?: AllVersion;
  learningPathCategory?: ICategory;
  courseCount?: string;
};

const CourseHeaderBannerBreadcrumb = ({
  courseName,
  learningPath,
  learningPathCategory,
  courseCount,
}: CourseHeaderBannerBreadcrumbProps) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  const breadcrumbList: IBreadcrumb[] = [
    {
      description: t('course_detail.header_banner.breadcrumb.homepage'),
      url: '/',
    },
    {
      description: courseName,
    },
  ];

  const selectCourseLearningPathBreadcrumbList: IBreadcrumb[] = [
    {
      description: t('course_detail.header_banner.breadcrumb.homepage'),
      url: '/',
    },
    {
      description: learningPath?.learningPathName ?? '',
      url: `/learning-path/${learningPath?.id}`,
    },
    {
      description: t('course_detail.breadcrumbs.category_title', { categoryName: learningPathCategory?.name ?? '' }),
      url: `/learning-path/${learningPath?.id}/${learningPathCategory?.slug}/${courseCount}`,
    },
    {
      description: courseName,
    },
  ];

  const breadcrumbs = (learningPath ? selectCourseLearningPathBreadcrumbList : breadcrumbList).map((item) => {
    if (!item.url) {
      return (
        <Typography
          key={`course-header-breadcrumb-${item.description}`}
          variant="BaseLegacy"
          color={theme.palette.textOnPrimary.secondary}
        >
          {item.description}
        </Typography>
      );
    }

    return (
      <NextLink key={`course-header-breadcrumb-${item.description}`} href={item.url}>
        <Button
          className="breadcrumb-link"
          variant="text"
          sx={{ color: '#FFF', textTransform: learningPath ? 'unset' : 'capitalize' }}
        >
          {item.description}
        </Button>
      </NextLink>
    );
  });

  return (
    <Box width="100%">
      <BreadCrumbs breadcrumbs={breadcrumbs} widthLastList="90%" color="#FFF" />
    </Box>
  );
};

export default CourseHeaderBannerBreadcrumb;
